import React from 'react';
import '../styles/PhilosophySection.css';

const PhilosophySection = () => {
  return (
    <section className="philosophy-section section-padding">
      <div className="container">
        <div className="philosophy-grid">
          <div className="philosophy-image-wrapper">
            <img 
              src="https://images.unsplash.com/photo-1461896836934-ffe607ba8211" 
              alt="High-performance athlete running"
              className="philosophy-image"
            />
          </div>
          <div className="philosophy-content">
            <h2 className="heading-1">
              <span className="accent-orange">Wellness-First</span><br />
              Philosophy
            </h2>
            <div className="philosophy-text">
              <p className="body-large">
                At Mushhrushh, we believe in long-term wellbeing over quick fixes. Our approach is rooted in patience, science, and respect for both nature and the human body.
              </p>
              <div className="philosophy-principles">
                <div className="principle-item">
                  <h3 className="heading-3">Clean Labels</h3>
                  <p className="body-regular">No fillers, no additives, no shortcuts. What you see is what you get — pure Cordyceps militaris.</p>
                </div>
                <div className="principle-item">
                  <h3 className="heading-3">Sustainable Practice</h3>
                  <p className="body-regular">Indoor cultivation that respects the environment while ensuring consistency and quality.</p>
                </div>
                <div className="principle-item">
                  <h3 className="heading-3">Conscious Consumption</h3>
                  <p className="body-regular">We empower you with knowledge to make informed decisions about your wellness journey.</p>
                </div>
              </div>
              <div className="philosophy-quote">
                <p className="body-large">
                  "From Our Farm to Your Wellness Ritual"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;